export const LOGO_DEFENSORIA_SRC = '/img/logo_branco.png';

/** Chave do token do candidato no localStorage (fluxo público do candidato). */
export const CANDIDATO_TOKEN_KEY = 'candidato_token';

/** Chave do token padrão/admin no localStorage (fallback em algumas rotas). */
export const DEFENSOR_TOKEN_KEY = '@defensor-token';

/** Domínio padrão do e-mail institucional de estagiários. */
export const EMAIL_INSTITUCIONAL_DOMINIO = '@defensoria.se.def.br';

